module.exports = __webpack_public_path__ + "static/media/linkedin.c3fcc390.png";